import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

import { baseTheme } from '../../../../../theme';
import { highlightStyleOptions } from '../../../../../contants/highlight-style-options';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      width: '25%',
      backgroundColor: theme.palette.background.paper,
      margin: '15vh auto',
      borderRadius: '10px',
    },
    formLabel: {
      fontWeight: 'bold',
    },
  }),
);
interface IHighlightSettingsProps {
  saveSettings: (textColor: string, textSize:string, textPosition: string, backgroundColor: string)
      => void;
  cancelSave: () => void;
  textColor: string;
  textSize: string;
  textPosition: string;
  backgroundColor: string;
}
export default function HighlightSettings(props: IHighlightSettingsProps) {
  const styles = useStyles(baseTheme);
  const { saveSettings, cancelSave } = props;
  const [textColor, setTextColor] = useState<string>(props.textColor || 'black');
  const [textSize, setTextSize] = useState<string>(props.textSize || 'small');
  const [textPosition, setTextPosition] = useState<string>(props.textPosition || 'middle');
  const [backgroundColor, setBackgroundColor] = useState<string>(props.backgroundColor || 'gray');

  const handleTextColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTextColor(event.target.value);
  };
  const handleTextSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTextSize(event.target.value);
  };
  const handleTextPositionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTextPosition(event.target.value);
  };
  const handleBackgroundColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBackgroundColor(event.target.value);
  };
  const handleSaveClick = () => {
    saveSettings(
        textColor,
        textSize,
        textPosition,
        backgroundColor,
    );
  };

  return (
    <div className={styles.root}>
      <FormLabel className={styles.formLabel}>Highlight Settings</FormLabel>
      <br/>
      <br/>
      <FormLabel className={styles.formLabel}>Text Color</FormLabel>
      <RadioGroup
        value={textColor}
        onChange={handleTextColorChange}
      >
        <FormControlLabel
          value={highlightStyleOptions.textColor.black.value}
          label={highlightStyleOptions.textColor.black.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.textColor.gray.value}
          label={highlightStyleOptions.textColor.gray.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.textColor.white.value}
          label={highlightStyleOptions.textColor.white.label}
          control={<Radio />}
        />
      </RadioGroup>
      <br/>
      <FormLabel className={styles.formLabel}>Text Size</FormLabel>
      <RadioGroup
        value={textSize}
        onChange={handleTextSizeChange}
      >
        <FormControlLabel
          value={highlightStyleOptions.textSize.small.value}
          label={highlightStyleOptions.textSize.small.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.textSize.medium.value}
          label={highlightStyleOptions.textSize.medium.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.textSize.large.value}
          label={highlightStyleOptions.textSize.large.label}
          control={<Radio />}
        />
      </RadioGroup>
      <br/>
      <FormLabel className={styles.formLabel}>Text Position</FormLabel>
      <RadioGroup
        value={textPosition}
        onChange={handleTextPositionChange}
      >
        <FormControlLabel
          value={highlightStyleOptions.textPosition.top.value}
          label={highlightStyleOptions.textPosition.top.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.textPosition.middle.value}
          label={highlightStyleOptions.textPosition.middle.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.textPosition.bottom.value}
          label={highlightStyleOptions.textPosition.bottom.label}
          control={<Radio />}
        />
      </RadioGroup>
      <br/>
      <FormLabel className={styles.formLabel}>Background Color</FormLabel>
      <RadioGroup
        value={backgroundColor}
        onChange={handleBackgroundColorChange}
      >
        <FormControlLabel
          value={highlightStyleOptions.backgroundColor.black.value}
          label={highlightStyleOptions.backgroundColor.black.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.backgroundColor.white.value}
          label={highlightStyleOptions.backgroundColor.white.label}
          control={<Radio />}
        />
        <FormControlLabel
          value={highlightStyleOptions.backgroundColor.gray.value}
          label={highlightStyleOptions.backgroundColor.gray.label}
          control={<Radio />}
        />
      </RadioGroup>
      <Button onClick={handleSaveClick} >Save</Button>
      <Button onClick={cancelSave} >Cancel</Button>
    </div>
  );
}
